import { getLocale } from "@umijs/max";
import enUS from "../../locales/errorCode/en-US.json";
import zhCN from "../../locales/errorCode/zh-CN.json";
import jaJP from "../../locales/errorCode/ja-JP.json";

const getDiffLocaleMessages = () => {
  const locale = getLocale();

  switch (locale) {
    case "zh-CN":
      return zhCN;
    case "ja-JP":
      return jaJP;
    case "en-US":
      return enUS;
  }
};

export const getErrorMessage = (code, defaultCode) => {
  const locale = getLocale();

  const messages = getDiffLocaleMessages();

  const unknown = locale === "zh-CN" ? "未知错误" : "Unknown error";

  return messages[code] || messages[defaultCode] || unknown;
};
